import { yup } from '@framework/validation/initYup.ts';
import { type YupArraySchema } from '@framework/validation/YupArraySchema.ts';
import {
  type IComputeExpressionValueReference,
  type IComputeExpressionValueText,
} from '../../../../expressions/compute/ComputeExpression.ts';
import { ComputeExpressionSchema } from '../../../../expressions/compute/validation/ComputeExpressionSchema.ts';
import { WidgetType } from '../../../Widget.ts';
import { BaseLayoutSchema } from '../../common/BaseLayoutSchema.ts';
import { CommonInputWidgetConfigSchema } from '../../inputs/common/CommonInputConfigComponent.tsx';
import { type IComputedStringWidget } from '../IComputedWidget.ts';

const ComputedStringExpressionSchema = yup
  .object({
    value: ComputeExpressionSchema.fields.value as YupArraySchema<
      IComputeExpressionValueReference | IComputeExpressionValueText
    >,
    raw: yup.string().label('Espressione').default('').required(),
  })
  .required()
  .noUnknown()
  .label('Espressione');

export const ComputedStringConfigSchema: yup.ObjectSchema<IComputedStringWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup
      .string()
      .required()
      .exact(WidgetType.ComputedString)
      .label('Tipo'),
    expression: ComputedStringExpressionSchema,

    layout: BaseLayoutSchema.shape({
      hide: yup.boolean().required().default(false).label('Nascondi elemento'),
      removeBorder: yup
        .boolean()
        .required()
        .default(false)
        .label('Rimuovi bordo'),
    }),
  })
    .required()
    .noUnknown();
